var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('t-nav-button',{on:{"click":_vm.onConnect}},[_vm._v(" Connect To Wallet ")])}
var staticRenderFns = []

export { render, staticRenderFns }